export default __webpack_public_path__ + "static/media/feature2_1.5b0b5db4.png";